import type { Slide as UISlide } from '@genially/document-components';
import type {
  AnyInteractiveQuestionItemData,
  AreaItemData,
  ArrowItemData,
  ChartItemData,
  ContainerBoxItemData,
  GeniallyData,
  GroupItemData,
  ImageItemData,
  PinItemData,
  RichContentItemData,
  SlideSerializedData as DMSlide,
  SvgItemData,
  TextItemData,
  WidgetAudioItemData,
  WidgetVideoItemData,
} from '@genially/document-model';
import { ItemType } from '@genially/document-model/build/module/items/ItemType';

type Slide = UISlide & DMSlide;

export enum GeniallyContentItemKey {
  Activities = 'activities',
  Areas = 'areas',
  Arrows = 'arrows',
  Audios = 'audios',
  BaseWidgets = 'baseWidgets',
  ContainerBoxes = 'containerBoxes',
  Charts = 'charts',
  Groups = 'groups',
  Images = 'images',
  Pins = 'pins',
  RichContents = 'richContents',
  Svgs = 'svgs',
  Texts = 'texts',
  Videos = 'videos',
}

// this is here just to ensure that the enum above is complete and so compilation
// fails if a new item type is added and this map is not updated
export const geniallyContentItemKeyMap: Record<ItemType, GeniallyContentItemKey> = {
  [ItemType.Activity]: GeniallyContentItemKey.Activities,
  [ItemType.Area]: GeniallyContentItemKey.Areas,
  [ItemType.Arrow]: GeniallyContentItemKey.Arrows,
  [ItemType.BaseWidget]: GeniallyContentItemKey.BaseWidgets,
  [ItemType.ContainerBox]: GeniallyContentItemKey.ContainerBoxes,
  [ItemType.Chart]: GeniallyContentItemKey.Charts,
  [ItemType.Group]: GeniallyContentItemKey.Groups,
  [ItemType.Image]: GeniallyContentItemKey.Images,
  [ItemType.Pin]: GeniallyContentItemKey.Pins,
  [ItemType.RichContent]: GeniallyContentItemKey.RichContents,
  [ItemType.Svg]: GeniallyContentItemKey.Svgs,
  [ItemType.Text]: GeniallyContentItemKey.Texts,
  [ItemType.WidgetAudio]: GeniallyContentItemKey.Audios,
  [ItemType.WidgetVideo]: GeniallyContentItemKey.Videos,
};

// This is an small set of the type GeniallyData from document model
// with camel-case item keys
// Dataformatters must be unified and in TS to remove this type
export interface GeniallyContent {
  slides: Slide[];

  [GeniallyContentItemKey.Activities]: AnyInteractiveQuestionItemData[];
  [GeniallyContentItemKey.Areas]: AreaItemData[];
  [GeniallyContentItemKey.Arrows]: ArrowItemData[];
  [GeniallyContentItemKey.Audios]: WidgetAudioItemData[];
  [GeniallyContentItemKey.BaseWidgets]: WidgetAudioItemData[];
  [GeniallyContentItemKey.ContainerBoxes]: ContainerBoxItemData[];
  [GeniallyContentItemKey.Charts]: ChartItemData[];
  [GeniallyContentItemKey.Groups]: GroupItemData[];
  [GeniallyContentItemKey.Images]: ImageItemData[];
  [GeniallyContentItemKey.Pins]: PinItemData[];
  [GeniallyContentItemKey.RichContents]: RichContentItemData[];
  [GeniallyContentItemKey.Svgs]: SvgItemData[];
  [GeniallyContentItemKey.Texts]: TextItemData[];
  [GeniallyContentItemKey.Videos]: WidgetVideoItemData[];

  documentConfig: GeniallyData['DocumentConfig'];

  genially: GeniallyData['Genially'];
  interactivityActions: GeniallyData['interactivityActions'];
}
